import resolveConfig from 'tailwindcss/resolveConfig';
import config from '~/tailwind.config.ts';

const fullConfig = resolveConfig(config);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useTailwind(): any {
  return fullConfig;
}
